import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'markdownBold', standalone: true })
@Injectable({providedIn: 'root'})
export class MarkdownBoldPipe implements PipeTransform {
	
	transform(value: string): string {
		return value.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
	}
}
